import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type CarerReview = {
  id: string;
  rating: number;
  comment: string;
  created_at: string;
  reviewer_name: string;
};

const useCarerReviews = (carerId: string) => {
  const queryFn = async (): Promise<CarerReview[]> => {
    const { data, error } = await supabaseClient.functions.invoke('get_carer_reviews', {
      method: 'POST',
      body: { carer_id: carerId },
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    console.log('Raw reviews data:', data);
    return data?.data?.reviews || data?.reviews || [];
  };

  return useQuery<CarerReview[], Error>({
    queryKey: ['carerReviews', carerId],
    queryFn,
    enabled: !!carerId,
  });
};

export default useCarerReviews;
